(function (){
  'use strict';

  angular.module('tfc.retailer.StandardReports')
      .directive('hierarchyFilter', HierarchyFilter)
      .controller('HierarchyFilterCtrl', HierarchyFilterCtrl);


  function HierarchyFilter(){
    return {
      restrict: 'E',
      scope : {
        addressable: '=',
        hierarchy: '=',
        addressableHierarchy: '=',
        selectedHierarchy: '='
      },
      controller : 'HierarchyFilterCtrl as vm',
      bindToController : true,
      templateUrl : 'StandardReports/Filters/HierarchyFilter/HierarchyDimension.tmpl.html'
    };
  }

  // @ng-inject
  function HierarchyFilterCtrl(){
    var vm = this;

    function init(selectedHierarchy) {
      vm.departments = getHierarchy();
      vm.selectedDepartment = _.find(vm.departments, { name: (selectedHierarchy && selectedHierarchy.department) ||
            getDefaultHierarchyValue() });
      vm.onDepartmentChange(selectedHierarchy);
      vm.islineItemTracking = vm.departments.length > 1;
    }


    vm.onDepartmentChange = function(selectedHierarchy) {
      updateHierarchy(vm.selectedDepartment.name, 0);
      vm.selectedHierarchy.department = vm.selectedDepartment.name;

      vm.categories = vm.selectedDepartment.values;
      vm.selectedCategory = _.find(vm.categories, { name: (selectedHierarchy && selectedHierarchy.category) ||
            getDefaultHierarchyValue() });
      vm.onCategoryChange(selectedHierarchy);
    };

    vm.onCategoryChange = function(selectedHierarchy) {
      updateHierarchy(vm.selectedCategory.name, 1);
      vm.selectedHierarchy.category = vm.selectedCategory.name;

      vm.classifications = vm.selectedCategory.values;
      vm.selectedClassification = _.find(vm.classifications, { name: (selectedHierarchy && selectedHierarchy.classification) ||
            getDefaultHierarchyValue() });
      vm.onClassificationChange(selectedHierarchy);
    };

    vm.onClassificationChange = function(selectedHierarchy) {
      updateHierarchy(vm.selectedClassification.name, 2);
      vm.selectedHierarchy.classification = vm.selectedClassification.name;
    };

    vm.toggleAddressable = function () {
      init();
    };

    function getDefaultHierarchyValue() {
      return vm.addressable ? 'All TrueFit Addressable' : 'All';
    }

    function getHierarchy() {
      return vm.addressable ? vm.addressableHierarchy : vm.hierarchy;
    }

    function updateHierarchy(hierarchyName, level) {
      function hierarchyLevelValues(values, level) {
        if(level === 0) { return values; }
        else {
          var selectedHierarchy = _.find(values, {isSelected: true});
          return hierarchyLevelValues(selectedHierarchy.values, level - 1);
        }
      }

      var hierarchyLevel = hierarchyLevelValues(getHierarchy(), level);
      _.forEach(hierarchyLevel, function (hierarchy) {
        hierarchy.isSelected = hierarchy.name === hierarchyName;
      })
    }

    init(vm.selectedHierarchy);

  }

})();